import React, { useState } from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';
import DialogContent from '@material-ui/core/DialogContent';
import { IMeterReadingsView } from '../../../../../../@types/model/transformer/reading/transformerReading';
import StadiumButton from '../../../../../customComponents/button/StadiumButton';
import DialogActions from '@material-ui/core/DialogActions';
import { IRootState } from '../../../../../../@types/redux';
import { connect } from 'react-redux';
import OutlinedStadiumButton from '../../../../../customComponents/button/OutlinedStadiumButton';
import AppFunctionsService from '../../../../../../services/appFunctionsService';
import ProjectDialog from '../../../../../customComponentV2/dialog/ProjectDialog';

interface ITransformerSPUReadingDeleteDialogProps {
    reading : IMeterReadingsView;

    onDelete ?: (reading : IMeterReadingsView) => void;
}

const TransformerSPUReadingDeleteDialogComponent = (props : ITransformerSPUReadingDeleteDialogProps) : React.ReactElement => {
    const [open, setOpen] = useState<boolean>(false);

    const onClick = () : void => {
        setOpen(true);
    };

    const onClose = () : void => {
        setOpen(false);
    };

    const onDeleteClick = async () : Promise<void> => {  
        if (props.onDelete) props.onDelete(props.reading);      
        onClose();
    };

    return (
        <div>
            <Tooltip title='Delete'>
                <div>
                    <IconButton className={'cr'} onClick={onClick}
                        aria-label='Delete'>
                        <Icon>delete</Icon>
                    </IconButton>
                </div>
            </Tooltip>
            <ProjectDialog
                isOpen={open}
                onClose={onClose}
                maxWidth={'md'}
                fullWidth
                headerColour={'red'}
                title={`REMOVE READING | ${AppFunctionsService.formatDateTimeToDateOnly(props.reading.Date)} | ${props.reading.EPNumber}`}
            >
                <DialogContent className='fdc flx1 ais hfill bcg0'>
                    <div className='fdc flx1 ais jcc'>
                        <p>
                            Remove Reading?
                        </p>
                        <p>
                            This will remove all associated readings too.
                        </p>
                    </div>
                </DialogContent>
                <DialogActions className='bcg0'>
                    <OutlinedStadiumButton className='mr16' variant='text' onClick={onClose}>
                        CANCEL
                    </OutlinedStadiumButton>
                    <StadiumButton variant='contained' onClick={onDeleteClick}>
                        REMOVE
                    </StadiumButton>
                </DialogActions>
            </ProjectDialog>
        </div>
    );
};

const mapStateToProps = (state : IRootState) => {
    return {
        attributes: state.data.transformerAttributes,
    };
};

const TransformerSPUReadingDeleteDialog = connect(
    mapStateToProps,
)(TransformerSPUReadingDeleteDialogComponent);

export default TransformerSPUReadingDeleteDialog;
